import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

instance.interceptors.request.use((config) => {
  const credentials = JSON.parse(localStorage.getItem("romotors_web_credentials") || '""');
  const lang = localStorage.getItem("romotors_web_lang") || "en";
  config.headers.Authorization = credentials ? `Bearer ${credentials.access_token}` : "";
  config.headers.accept = "application/json";
  config.headers["Accept-Language"] = lang;
  return config;
});

export default instance;
